import React, { useState, useEffect, useCallback } from 'react';
import h from '../../helpers/common';
import { MenuList } from '@intigral/shared';
import { MenuItem } from '@intigral/shared/components/MenuList';
import { Link } from 'react-router-dom';

interface SelectDropdownProps {
    items: { label: Record<string, string>; [key: string]: any }[];
    onChange: (value) => void;
    listTypeClass: string;
    selected: string | number;
    activeClass: string;
}

const SelectDropdown: React.FC<SelectDropdownProps> = ({
    items,
    onChange = null,
    listTypeClass = '',
    selected = '',
    activeClass = 'active',
}) => {
    const [currentValue, setCurrentValue] = useState(selected);
    const [currentLabel, setCurrentLabel] = useState('');

    const updateSelect = useCallback(
        (item) => {
            setCurrentValue(item.value);
            setCurrentLabel(item.label[h.getLang()]);
            if (onChange) {
                onChange(item.value);
            }
        },
        [onChange]
    );

    const getCurrentLabel = useCallback(() => {
        let selectedItem = items.find((item) => item.value === currentValue);
        if (!selectedItem && items.length > 0) {
            selectedItem = items[0];
        }
        return selectedItem ? selectedItem.label[h.getLang()] : 'Undefined';
    }, [currentValue, items]);

    useEffect(() => {
        if (items.length > 0) {
            setCurrentValue(selected || items[0].value);
            setCurrentLabel(getCurrentLabel());
        }
    }, [items, selected, getCurrentLabel]);

    return (
        <MenuList
            triggerTitle={currentLabel}
            dropIcon="chevron-left"
            className={listTypeClass}
            align="start"
            selectedItem={currentValue}
            onChange={(value) => {
                const item = items.find((i) => i.value === value);
                if (item) {
                    updateSelect(item);
                }
            }}
        >
            {items.map((item, index) => {
                const value = item.value;
                return (
                    <MenuItem
                        key={index}
                        selected={value === currentValue}
                        variant="link"
                        onClick={(e) => {
                            e?.preventDefault();
                            updateSelect(item);
                        }}
                        linkAs={Link}
                        to={item.type === 'url' ? item.url : '#'}
                        className={value === currentValue ? activeClass : ''}
                    >
                        {item.type === 'image' ? (
                            <img src={item.imageUrl} alt={item.label[h.getLang()]} />
                        ) : (
                            item.label[h.getLang()]
                        )}
                    </MenuItem>
                );
            })}
        </MenuList>
    );
};

export default SelectDropdown;
